import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column } from "@faire/web--source/slate/Layout";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api--source/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import React from "react";
import { useSettingLoggedOutHomepageRedesignV2 } from "@faire/retailer/settings/useSettingLoggedOutHomepageRedesignV2";
import { BottomSignUpBannerContent } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/BottomSignUpBannerContent/BottomSignUpBannerContent";
import { BottomSignUpBannerImages } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/BottomSignUpBannerImages";
import { MoreToExplorePills } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/MoreToExplorePills/MoreToExplorePills";
import * as componentStyles from "./styles.css";
export var BottomSignUpBanner = function() {
    var homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
    var ref = useDoActionWhenVisible(function() {
        return trackLoggedOutRetailersLoggedOutHomeRedesignView("perfect_product_banner", "".concat(homepageRedesignVariant));
    });
    return /*#__PURE__*/ _jsxs(Column, {
        className: componentStyles.wrapper,
        align: "center",
        justify: {
            mobileAndAbove: "end",
            tabletAndAbove: "center"
        },
        "data-test-id": "bottom-sign-up-banner",
        gap: "4x",
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(BottomSignUpBannerImages, {}),
            /*#__PURE__*/ _jsx(BottomSignUpBannerContent, {}),
            /*#__PURE__*/ _jsx(WhenVisibilityIsImminent, {
                children: /*#__PURE__*/ _jsx(MoreToExplorePills, {})
            })
        ]
    });
};
